var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("颜色监控")]),_c('div',{staticClass:"monitor_section"},[_c('device-color-status',{attrs:{"jt_id":_vm.jt_id,"jt_status":_vm.jt_status}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }